import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'
import z from 'zod/v3'
import { withRoutePermissions } from '~/utils/rbac'
import AddEntreprisePage1 from '../../../components/routes/companies/AddEntreprisePage1'
import AddEntreprisePage2 from '../../../components/routes/companies/AddEntreprisePage2'
import EntrepriseOutletProvider from '../../../components/routes/companies/EntrepriseOutletProvider'
export const stepsSchema = z
  .union([z.literal(1), z.literal(2)])
  .optional()
  .default(1)

export type Step = z.infer<typeof stepsSchema>

export const Route = createFileRoute('/_authenticated/companies/new')({
  staticData: {
    permission: ['add', 'works-council.works-council.partnership'],
  },
  component: RouteComponent,
  validateSearch: z.object({
    step: stepsSchema,
  }),
})
withRoutePermissions(Route)

const stepComponents = {
  1: AddEntreprisePage1,
  2: AddEntreprisePage2,
} satisfies Record<Step, () => JSX.Element>

function RouteComponent() {
  const { step } = Route.useSearch()

  const Component = stepComponents[step]

  return (
    <EntrepriseOutletProvider worksConcilId={undefined}>
      <Component />
    </EntrepriseOutletProvider>
  )
}
